import apiClient from '../apiClient';

export const loginAdmin = async (email, password) => {
  const response = await apiClient.post('/admin/login', { email, password });
  const token = response.data.access_token;
  if (token) {
    localStorage.setItem('adminToken', token);
  }
  return token;
};

export const getAdminProfile = async () => {
  const response = await apiClient.get('/admin/profile');
  return response.data;
};

export const logoutAdmin = () => {
  localStorage.removeItem('adminToken');
};
